import DasSlider from './DasSlider';
import DasSliderContainer from './DasSlider.container';

export default DasSliderContainer(DasSlider);
